import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ManageFolders from "../../../ClassSettings/routes/ManageFolders";
export default store => ({
  path: "journal",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "journal" */ "../../../ClassSettings/components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ManageFolders(store)],
});
